/**
 * Internal
 */
import { createReducer } from 'state/utils';
import * as actions from 'state/action-types';

export default createReducer(null, {
	[actions.SET_OPERATION_LAST_RAN]: (state, action) => {
		return action.payload.operation;
	},
});
